import React from "react";
import { Document, Page, Text, View, StyleSheet, Image, Link } from "@react-pdf/renderer";
import "../assets/fonts/roboto"; // Import registrace fontu

// Styl PDF
const styles = StyleSheet.create({
    page: {
        padding: 40,
        fontFamily: "Roboto",
        backgroundColor: "#ffffffff",
    },
    logo: {
        width: 75,
        height: "auto",
        marginBottom: 20,
        alignSelf: "center",
        objectFit: "contain",
    },

    banner: {
        width: 300,
        height: 150,
        marginBottom: 20,
        alignSelf: "center",
        objectFit: "contain",
    },


    header: {
        fontSize: 20,
        fontWeight: "bold",
        color: "#1c192c",
        textAlign: "center",
        marginBottom: 20,
        textTransform: "uppercase",
    },
    section: {
        marginBottom: 20,
        paddingBottom: 5,
        borderBottomWidth: 2,
        borderBottomColor: "#E51937",
        borderBottomStyle: "solid",
        padding: 10,
        backgroundColor: "#f8f9fa",
        borderRadius: 15,
        shadowColor: "#000",
        shadowOpacity: 0.1,
    },
    boldText: {
        fontWeight: "bold",
        fontSize: 13,
        color: "#1c192c",
        marginBottom: 4,
    },
    normalText: {
        fontSize: 10,
        fontWeight: "normal",
        color: "#1c192c",
        lineHeight: 1.6,
    },
    listItem: {
        fontSize: 10,
        marginBottom: 3,
        paddingLeft: 10,
        color: "#1c192c",
    },
    footer: {
        marginTop: 30,
        textAlign: "center",
        fontSize: 8,
        fontWeight: "normal",
        color: "#000000ff",
    },
    motivation: {
        textAlign: "center",
        fontSize: 10,
        fontWeight: "bold",
        color: "#E51937",
        marginTop: 20,
        padding: 10,
        backgroundColor: "#f8f9fa",
        borderRadius: 5,
    },
    barContainer: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 5,
    },
    barLabel: {
        width: 80,
        fontSize: 13,
        fontWeight: "bold",
    },
    bar: {
        height: 12,
        borderRadius: 6,
    },
    cardioBar: {
        backgroundColor: "#1c192c",
    },
    strengthBar: {
        backgroundColor: "#E51937",
    },

    linkText: {
        fontSize: 10,
        color: "#1a0dab",
        textAlign: "center",
        marginTop: 5,
        textDecoration: "underline",
    },
});

// PDF komponenta
const TrainingSummaryPDF = ({ exercises, feeling, comment, avgCardio, avgStrength, numSets  }) => {
    // Normalizace průměrných hodnot do procent (max 7 bodů)
    const cardioPercent = ((avgCardio || 0) / 10) * 100;
    const strengthPercent = ((avgStrength || 0) / 10) * 100;

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {/* Logo nahoře */}
                <Image src="/images/logo.png" style={styles.logo} />

                {/* Nadpis PDF */}
                <View style={styles.header}>
                    <Text>Přehled Tabata tréninku</Text>
                </View>

                {/* Datum */}
                <View style={styles.section}>
                    <Text style={styles.boldText}>Datum a čas cvičení</Text>
                    <Text style={styles.normalText}>{new Date().toLocaleString("cs-CZ")}</Text>
                </View>

{/* Průměrné kardio a síla s vizualizací */}
<View style={styles.section}>
    <Text style={styles.boldText}>Náročnost tréninku</Text>
                    <View style={{ marginTop: 10 }}>
                        <View style={styles.barContainer}>
                            <Text style={styles.barLabel}>Kardio:</Text>
                            <View style={{ flex: 1, backgroundColor: "#dcdcdc", borderRadius: 6 }}>
                                <View style={[styles.bar, styles.cardioBar, { width: `${cardioPercent}%` }]} />
                            </View>
                            <Text style={{ marginLeft: 5 }}>{avgCardio?.toFixed(1)} / 10</Text>
                        </View>

                        <View style={styles.barContainer}>
                            <Text style={styles.barLabel}>Síla:</Text>
                            <View style={{ flex: 1, backgroundColor: "#dcdcdc", borderRadius: 6 }}>
                                <View style={[styles.bar, styles.strengthBar, { width: `${strengthPercent}%` }]} />
                            </View>
                            <Text style={{ marginLeft: 5 }}>{avgStrength?.toFixed(1)} / 10</Text>
                        </View>
                    </View>
                    <Text style={styles.barLabel}>Počet sérií: {numSets}</Text>
                    </View>




                {/* Odcvičené cviky */}
                <View style={styles.section}>
                    <Text style={styles.boldText}>Odcvičené cviky</Text>
                    {exercises.length > 0 ? (
                        exercises.map((exercise, index) => (
                            <Text key={index} style={styles.listItem}>
                                {index + 1}. {exercise?.name || "Neznámý cvik"}
                            </Text>
                        ))
                    ) : (
                        <Text style={styles.normalText}>Žádné cviky nebyly odcvičeny.</Text>
                    )}
                </View>

                {/* Hodnocení tréninku */}
                <View style={styles.section}>

                    <Text style={styles.boldText}>Hodnocení tréninku</Text>
                    {/*<Text style={styles.normalText}>Náročnost cvičení - {feeling || "Nezadáno"}</Text>*/}
                    {comment && <Text style={styles.normalText}>Komentář - {comment}</Text>}

                 
                </View>

                {/* Motivační hláška 
                <View style={styles.motivation}>
                    <Text>Skvělá práce! Jsi o krok blíže k lepší kondici!</Text>
                </View>
                */}

             {/* Reklamni banner a odkaz na web
          
                <Image src="/images/banner.png" style={styles.banner} />
                <Link src="https://tabataworkout.cz" style={styles.linkText}>
                        Více o Tabatě na TabataWorkout.cz
                    </Link>
             */}     


                {/* Footer */}
                <View style={styles.footer}>
                    <Text>Cvičte efektivně. Děkujeme, že k dosažení svého cíle používáte webovou aplikaci <Link src="https://tabataworkout.online">TabataWorkout.online</Link></Text>
                </View>
                
            </Page>
        </Document>
    );
};

export default TrainingSummaryPDF;
